import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { CommonModule } from '@angular/common';
import { DynamicFooterService } from '@core/services/dynamic-footer.service';
import { PlatformService } from '@core/services/platform.service';
@Component({
  selector: 'app-dynamic-footer',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './dynamic-footer.component.html',
  styleUrls: ['./dynamic-footer.component.scss']
})
export class DynamicFooterComponent implements OnInit {

  footerList: any[];
  isSkeletonFooter = true;
  isLaunchPage = false;
  countryCode = '';
  currentPageSeoFooter = '';
  currentGameCategory = '';
  gameCategoryFooter = {
    'sports': ['wbet', 'cmd'],
    'casino': ['dg', 'bg', 'sexy', 'evo', 'sa'],
    'slots': ['cq9', 'kiss', 'mega', 'pp', 'live', 'sg', 'next', 'haba'],
    'esport': ['cmd'],
  };
  showRow = 0;
  lastRow = 0;

  environment = environment;
  sitePrefix = environment.sitePrefix.toLowerCase();
  projectCode = environment.projectCode.toLocaleLowerCase();
  ambassador = environment.ambassador;
  siteName = environment.siteName;
  languageCode = environment.defaultLanguage;
  isQP14 = this.projectCode == 'qp14';
  isQP2D = this.projectCode == 'qp2d';
  isQP19 = this.projectCode == 'qp19';
  currentRoute: string = '';
  readMore: boolean = false;

  constructor(
    public translateService: TranslateService,
    private dynamicFooterService: DynamicFooterService,
    private eventEmitterService: EventEmitterService,
    private platformService: PlatformService,
    private router: Router) {
    if (this.isQP14) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
      ).subscribe(() => {
        this.currentRoute = location.pathname;
        this.readMore = false;
      });
    }
  }

  ngOnInit(): void {
    this.getFooter();
    if (this.platformService.isBrowser()) {
      this.isLaunchPage = window.location.pathname === '/gamelaunch' ? true : false;
      this.countryCode = localStorage.getItem('country_code');
      this.languageCode = localStorage.getItem('language_code')?.toLowerCase();
      this.currentRoute = location.pathname;

      this.eventEmitterService.updateFooterVar = this.eventEmitterService.updateFooterEmitter.subscribe(() => {
        this.getFooter();
      });
    }
  }

  getFooter() {
    this.dynamicFooterService.getFooter().subscribe((res) => {
      this.footerList = res;
      if (res.length > 0) {
        this.lastRow = res[res.length - 1]['web_row'];
      }

      this.isSkeletonFooter = false;
    })
  }

  getCurrentYear() {
    return new Date().getFullYear()
  }

  counter(i: number) {
    return new Array(i);
  }

  updateShowRowSpace(number: number) {
    this.showRow = number;
  }

  hasIcons(item: any) {
    for (const i of item) {
      if (i.icon_path) {
        return true;
      }
    }

    return false;
  }

  onRedirect(link: string) {
    if (link !== '') {
      if (link.includes('/external?link=')) {
        var redirectTO = link.replace('/external?link=', '');
        window.open(redirectTO, '_blank');
      } else {
        this.router.navigateByUrl(link);
      }
    }
  }

  toggleReadMore() {
    this.readMore = !this.readMore;
  }
}
